import * as React from 'react';
import { Component } from 'react';

import '../Taxi/TaxiHomeView.scss';
import { PCRClinic, Promocode } from '../../../models/Promocodes/promocodes';
import i18next from 'i18next';
import { copyToClipboard } from '../../../lib/utils';
import { toast, ToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import InfiniteScroll from 'react-infinite-scroll-component';
import Geocode from 'react-geocode';
import { Location } from '../../../models/Delivery/Delivery';

const clearIcon = require('../../../assets/Clear.svg');
const iconMapLocation = require('../../../assets/transfer_location.svg');
const iconCurrentPosition = require('../../../assets/current_position.svg');
const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY as string; // Google Maps API key

interface PcrHomeViewProps {
    promocodes: Promocode[] | null;
    error: string;
    getPromocodes: () => any;
    lang: string;
    clinics: Array<PCRClinic>;
    preferredClinic: number[];
    fullAddress: string;
    shortAddress: string;
    isHomeClinic: boolean;
    setClinics: (key: number) => any;
    setIsMap: (isMap: boolean) => any;
    setShortAddress: (address: string) => any;
    setFullAddress: (address: string) => any;
}

export default class PcrHomeView extends Component<PcrHomeViewProps> {

    googleMapsOptions = {
        types: ['geocode'],
        componentRestrictions: { country: this.props.lang }
    };

    private googleAutocomplete: any;

    componentDidMount() {
        Geocode.setLanguage(this.props.lang);
        Geocode.setApiKey(API_KEY);
        Geocode.setRegion(this.props.lang);
        this.loadGooglePlaces();
    }

    async searchAddresses(search: string) {
        if (search) {
            const results = await Geocode.fromAddress(search);
            return results.results.map((it: any): Location => ({
                address: it.formatted_address,
                lat: it.geometry.location.lat,
                lng: it.geometry.location.lng,
            }));
        }
    }

    loadGooglePlaces = () => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}&libraries=places&language=ru`;
        window.document.head.appendChild(script);

        script.onload = () => {
            this.bindAutoComplete();
        };
    }

    bindAutoComplete(): void {
        const elem = document.getElementById('autocomplete');
        // @ts-ignore
        this.googleAutocomplete = new google.maps.places.Autocomplete(elem, this.googleMapsOptions);
        this.googleAutocomplete.setFields(['address_components', 'formatted_address', 'name']);
        this.googleAutocomplete.addListener('place_changed', this.handlePlaceSelect);
    }

    handlePlaceSelect = () => {
        // Extract City From Address Object
        const addressObject = this.googleAutocomplete.getPlace();
        const address = addressObject.address_components;
        if (address) {
            this.props.setShortAddress!(addressObject.name + ' ');
            this.props.setFullAddress!(addressObject.formatted_address);
        }
    }

    geolocate = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                var geolocation = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                // @ts-ignore
                var circle = new google.maps.Circle(
                    {center: geolocation, radius: position.coords.accuracy});

                this.googleAutocomplete.setBounds(circle.getBounds());
            });
        }
    }

    useLocation() {
        const success = async (position: any) => {
            const latitude  = position.coords.latitude;
            const longitude = position.coords.longitude;

            const result = await Geocode.fromLatLng(latitude, longitude);
            const address = await this.searchAddresses!(result.results[0].formatted_address);
            this.props.setShortAddress!(address.address || result.results[0].formatted_address);
            this.props.setFullAddress!(address.address || result.results[0].formatted_address);
        };

        const error = (e: any) => {
            console.warn(`Error with code ${e.code}: ${e.message}`);
        };

        navigator.geolocation.getCurrentPosition(success, error);
    }

    notify = () => toast.success(i18next.t('code_copied_successfully'));
    notifyAddressInfo = () => toast.info(i18next.t('write_your_address'));
    notifyDisclaimerInfo = () => toast.info(i18next.t('pcr_home_disclaimer'), {delay: 1000});

    componentDidUpdate(prevProps: Readonly<PcrHomeViewProps>, prevState: Readonly<{}>, snapshot?: any) {
        if (prevProps.isHomeClinic !== this.props.isHomeClinic && this.props.isHomeClinic!!) {
            this.notifyAddressInfo();
            this.notifyDisclaimerInfo();
        }
    }

    render() {
        const { promocodes, error, clinics, preferredClinic, shortAddress, isHomeClinic, fullAddress,
            setIsMap, setClinics, getPromocodes } = this.props;
        return (
            <>
                <ToastContainer
                    position={'top-center'}
                    hideProgressBar={false}
                    closeOnClick={true}
                    draggable={true}
                    autoClose={false}
                />
                <div className='taxi-container'>
                    <div className='flex'>
                        <img src={require('../../../assets/pcr-promocode.png')} />
                    </div>
                    <div className='taxi-container__title'>
                        {i18next.t('pcr')}
                    </div>
                    {i18next.t('pcr_promocode_description')}
                    <div className='taxi-container__title'>
                        {i18next.t('how_to_use_pcr_promocode')}?
                    </div>
                    <div>
                        1. {i18next.t('get_promocodes')}
                    </div>
                    <div>
                        2. {i18next.t('choose_a_preffered_location')}
                    </div>
                    <div>
                        3. {i18next.t('present_promocode_at_the_lab')}
                    </div>
                    <div className='taxi-container__title'>
                        {i18next.t('if_you_have_any_questions')}
                    </div>
                    <div>
                        {i18next.t('contact_our_medical_curators')}
                    </div>
                    <div className='taxi-container__subtitle'>
                        {i18next.t('keti_dzidziguri')}
                    </div>
                    <div className='flex'>
                        <img src={require('../../../assets/blue_mail_icon.svg')} className='clinic_check-box'/>
                        <a href={'mailto:kdzidziguri@med-diagnostics.ge'}>kdzidziguri@med-diagnostics.ge</a>
                    </div>
                    <div className='flex'>
                        <img src={require('../../../assets/blue_phone_icon.svg')} className='clinic_check-box'/>
                        <a href={'tel:+995599399672'}>+995 599 399 672</a>
                    </div>
                    <div className='taxi-container__subtitle'>
                        {i18next.t('mariam_dzidziguri')}
                    </div>
                    <div className='flex'>
                        <img src={require('../../../assets/blue_mail_icon.svg')} className='clinic_check-box'/>
                        <a href={'mailto:Mdzidziguri@md.ge'}>Mdzidziguri@md.ge</a>
                    </div>
                    <div className='flex'>
                        <img src={require('../../../assets/blue_phone_icon.svg')} className='clinic_check-box'/>
                        <a href={'tel:+995551433144'}>+995 551 433 144</a>
                    </div>
                    <div className='taxi-container__title'>
                        {i18next.t('labaratory_addresses')}
                    </div>
                    {clinics && clinics.length > 0 && <InfiniteScroll
                        dataLength={clinics.length}
                        next={() => console.log()}
                        hasMore={false}
                        endMessage={<div/>}
                    >
                        {clinics.map(clinic => <div key={clinic.id} className='flex' onClick={() => setClinics(clinic.id)}>
                            <img
                                src={preferredClinic.indexOf(clinic.id) === -1
                                    ? require('../../../assets/check_box_gray.svg')
                                    : require('../../../assets/check_box_gray_checked.svg')}
                                className='clinic_check-box'
                            />
                            {clinic.name}
                        </div>)}
                    </InfiniteScroll>}
                    <div className='transfers' style={!isHomeClinic ? {display: 'none'} : {}}>
                        <div className='transfer-field'>
                            <div className='taxi-container__subtitle'>
                                {i18next.t('address')}
                            </div>
                            <div className='transfer-place-search datetime'>
                                <input
                                    id='autocomplete'
                                    className='transfer-input place'
                                    value={shortAddress}
                                    placeholder={i18next.t('write_your_address')}
                                    onChange={v => {
                                        this.props.setShortAddress!(v.target.value);
                                        this.props.setFullAddress!(v.target.value);
                                    }}
                                    onFocus={this.geolocate}
                                    type='text'
                                />
                                <img
                                    src={clearIcon}
                                    className={shortAddress!.length > 0 ? 'shown' : 'hidden'}
                                    onClick={() => {
                                        this.props.setShortAddress!('');
                                        this.props.setFullAddress!('');
                                    }}
                                />
                                <img
                                    src={iconCurrentPosition}
                                    style={shortAddress!.length > 0 ? {zIndex: 0} : {zIndex: 1}}
                                    onClick={() => this.useLocation()}
                                />
                            </div>
                        </div>
                        <div
                            className='show-on-map-button'
                            onClick={() => setIsMap(true)}
                        >
                            <img
                                src={iconMapLocation}
                                className='transfer-icons map-location'
                            />
                            {i18next.t('show_on_map')}
                        </div>
                    </div>
                </div>
                {!error && <div className={`taxi-container__button ${isHomeClinic ? fullAddress.length > 0 ? '' : 'gray' : ''}`}>
                    <button
                        onClick={() => {
                            if (promocodes) {
                                copyToClipboard(promocodes.map(prom => prom.code).join(','));
                                this.notify();
                            } else {
                                if (isHomeClinic && fullAddress.length === 0) {
                                    return;
                                }
                                getPromocodes();
                            }
                        }}
                    >
                        {promocodes ? `${i18next.t('copy')} ${promocodes.map(prom => prom.code).join(',')}`
                            : i18next.t('get_promocode')}
                    </button>
                </div>}
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Promocodes/Pcr/PcrHomeView.tsx